import React from 'react';

export const Title = ({ value }) => {
    return (
        <div className="text-gray-400 uppercase text-sm mb-3">
            {value}
        </div>
    )
};